import { configureStore } from '@reduxjs/toolkit';
import formReducer from '../Features/jobForms/jobFormSlice';

const store = configureStore({
    reducer: {
        form: formReducer,
    },
});

export default store;